var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"title":"Manage Users"},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('create-user',{on:{"success":_vm.reloadUsers}})]},proxy:true}])},[_vm._v(" "),_c('users-table',{attrs:{"title":"All Users","users":_vm.users}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }